import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, browserHistory } from 'react-router';
import { css } from '@emotion/core';
import { FaCheck } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

import ProductThumbnail from '../../shared/ProductThumbnail/ProductThumbnail';
import {
  removeFromCart,
  updateCartQuantity,
  getCartTotal,
  getCartTotalDiscountedCoupon,
  getDiscount,
  getMaxAddable,
  getCartTotalDiscountable,
} from '../../../redux/modules/cart';
import {
  setCoupon,
  resetCoupon,
  getCoupon,
  isValidCoupon,
} from '../../../redux/modules/checkout';
import {
  removeFromCartEvent,
  checkoutStep,
  pushRemarketingEvent,
} from '../../shared/lib/gaEnhancedEcommerce';
import Price from '../../shared/Price/Price';
import ProdottoCarrello from './ProdottoCarrello/ProdottoCarrello';
import MessaggioChiusura from '../../shared/MessaggioChiusura/MessaggioChiusura';
import Button from '../../shared/Button/Button';
import IubendaCookieSolution from '../../../utils/iubenda';
import {
  ga4AddToCart,
  ga4BeginCheckout,
  ga4RemoveFromCart,
  ga4ViewCart,
} from '../../shared/lib/ga4EnhancedEcommerce';
import {
  fkmxAddToCart,
  fkmxBeginCheckout,
  fkmxRemoveFromCart,
  fkmxViewCart,
} from '../../shared/lib/farmakomMetrics';
import { getSHA256Hash } from '../../../utils/sha256';
import Threshold from '../../shared/Threshold/Threshold';
import FidelityPoint from '../../shared/FidelityPoint/FidelityPoint';
import FidelityPointsEarned from '../../shared/FidelityPointsEarned/FidelityPointsEarned';
import { loadRecommendedItems } from '../../../redux/modules/recommendedItems';
import lightOrDark from '../../shared/SlickArrow/colorArrowFunction';

import './Carrello.scss';

class Carrello extends Component {
  constructor(props) {
    super(props);
    this.state = {
      couponCode: '',
      productQuantities: {},
      selectedCategory: 'Cosmetici',
    };
  }

  ///////////////////////////////////
  // GOOGLE ANALYTICS: STEP 1
  gaStep1(cart) {
    const productsGA = cart.map(p => ({
      id: p.code || '',
      name: p.name,
      category: p.categoryName,
      brand: p.brand,
      price: p.price,
      quantity: p.quantity,
    }));
    // SEND EVENT AFTER 1 SEC
    setTimeout(() => {
      checkoutStep(productsGA, 1);
    }, 1000);
  }

  async componentDidMount() {
    // Load recommended items by category
    this.props.loadRecommendedItems();

    // IUBENDA
    const iubenda = new IubendaCookieSolution(
      this.props.hasIubendaCookieSolution
    );

    // Eventuale coupon da Worldz
    const couponQuery = this.props.router.location.query.c;

    // Eventuale coupon da localStorage
    const couponLs =
      typeof localStorage !== 'undefined' ? localStorage.getItem('coupon') : '';
    let currentCouponCode = this.props.coupon.code;

    // Eliminazione coupon da Worldz
    if (couponQuery === '') {
      this.props.setCoupon('');
      currentCouponCode = '';
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('coupon', '');
      }
    } else {
      // No querystring c=<vuoto>
      const presetCoupon = couponQuery || couponLs;
      if (presetCoupon) {
        // Se coupon da Worldz, lo setto in Redux e lo testo con API
        this.props.setCoupon(presetCoupon);
        currentCouponCode = presetCoupon;
        if (typeof localStorage !== 'undefined') {
          localStorage.setItem('coupon', presetCoupon);
          this.setState({ couponCode: presetCoupon });
        }
      }
    }

    // Test coupon (potrebbe non essere più
    // valido in base al contenuto del carrello
    this.props.getCoupon(currentCouponCode);

    // GOOGLE ANALYTICS STEP 1
    if (this.props.advancedGa && this.props.cart) {
      this.gaStep1(this.props.cart);
    }

    // REMARKETING DINAMICO
    if (this.props.hasDynamicRemarketing) {
      pushRemarketingEvent('cart', this.props.cart);
    }

    // CRITEO CART TAG
    if (this.props.hasCriteo) {
      if (this.props.cart.length > 0) {
        iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
      }
    }

    // GA4 VIEW CART
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4ViewCart(this.props.cart, this.props.cartTotalDiscounted);
    }

    // FKMX VIEW CART
    if (this.props.hasFarmakomMetrics) {
      fkmxViewCart(this.props.cart, this.props.cartTotalDiscounted);
    }
  }

  renderCartTotal() {
    return this.props.cart.reduce((total, product) => {
      return total + product.price * product.quantity;
    }, 0);
  }

  componentDidUpdate(oldProps) {
    if (
      this.props.cart.length !== oldProps.cart.length &&
      this.props.cart.length > 0
    ) {
      const iubenda = new IubendaCookieSolution(
        this.props.hasIubendaCookieSolution
      );

      if (this.props.hasCriteo) {
        iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
      }

      if (this.props.hasDynamicRemarketing) {
        pushRemarketingEvent('cart', this.props.cart);
      }

      // GA4 VIEW CART
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4ViewCart(this.props.cart, this.props.cartTotalDiscounted);
      }

      // FKMX VIEW CART
      if (this.props.hasFarmakomMetrics) {
        fkmxViewCart(this.props.cart, this.props.cartTotalDiscounted);
      }

      if (this.props.coupon.code && this.props.coupon.code.length > 2) {
        this.setState({ couponCode: this.props.coupon.code });
      }
    }
    if (this.props.cartTotal !== oldProps.cartTotal) {
      // Load recommended items by category
      this.props.loadRecommendedItems();
    }
  }

  handleApplyCoupon = () => {
    const { couponCode } = this.state;
    if (!!couponCode) {
      this.props.setCoupon(couponCode);

      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('coupon', couponCode);
      }

      if (couponCode.length > 2) {
        this.props.getCoupon(couponCode);
      }
    }
  };

  handleResetCoupon = () => {
    this.setState({ couponCode: '' });
    this.props.resetCoupon();
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('coupon');
    }
  };

  renderCriteoTag = () => {
    // <!-- Criteo Basket/Cart Tag -->
    const user = this.props.user.data;
    const email = (user && user.email) || '';
    const zipcode = (user && user.shipping && user.shipping.zipcode) || '';

    // creo cart items
    const cartItems = this.props.cart.reduce((acc, curr) => {
      return (
        acc +
        `{id: "${curr.id}", price: ${curr.price}, quantity: ${curr.quantity} },`
      );
    }, ``);

    // rimuovo il vecchio tag
    const oldTag = document.getElementById('criteo_cart_tag');
    if (oldTag) {
      document.body.removeChild(oldTag);
    }

    const criteo_cart_tag = document.createElement('script');
    criteo_cart_tag.id = 'criteo_cart_tag';
    criteo_cart_tag.type = 'text/javascript';
    criteo_cart_tag.innerHTML = `
        window.criteo_q = window.criteo_q || [];
        var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
        window.criteo_q.push(
        { event: "setAccount", account: ${this.props.criteoAccountId}},
        { event: "setEmail", email: "${getSHA256Hash(
          email
        )}", hash_method: "sha256" },
        { event: "setZipcode", zipcode: "${zipcode}" },
        { event: "setSiteType", type: deviceType},
        { event: "viewBasket", item: [
          ${cartItems}
        ]});
    `;
    setTimeout(() => {
      document.body.appendChild(criteo_cart_tag);
    }, 200);
    // <!-- END Criteo Basket/Cart Tag -->
  };

  componentWillReceiveProps(nextProps) {
    // GOOGLE ANALYTICS STEP 1
    if (nextProps.advancedGa && nextProps.cart !== this.props.cart) {
      this.gaStep1(nextProps.cart);
    }
  }

  decrement = product => event => {
    event.preventDefault();
    if (!product.isFreeCorrelatedProduct) {
      const quantity = this.props.cart
        .filter(pr => pr.id === product.id)
        .reduce((acc, current) => acc + current.quantity, 0);
      if (quantity > 1) {
        this.props.updateCartQuantity(product.id, quantity - 1).then(() => {
          if (this.props.coupon.code && this.props.coupon.code.length > 2) {
            this.props.getCoupon(this.props.coupon.code);
          }
        });
      }
      // GA4 REMOVE FROM CART
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4RemoveFromCart({ ...product, quantity: 1 });
      }

      // FKMX REMOVE FROM CART
      if (this.props.hasFarmakomMetrics) {
        fkmxRemoveFromCart({ ...product, quantity: 1 });
      }
    }
  };

  increment = product => event => {
    event.preventDefault();

    if (!product.isFreeCorrelatedProduct) {
      const maxAddable = getMaxAddable(this.props.globalState, product);
      const { minNumInCart } = product;

      if (maxAddable > 0) {
        // la quantity del product diventa la somma delle quantity considerando anche i free
        const quantity = this.props.cart
          .filter(pr => pr.id === product.id)
          .reduce((acc, current) => acc + current.quantity, 0);

        // Posso aggiungere al carrello
        let newQuantity = quantity + 1;

        // Se c'è una quantità minima carrello e non l'ho raggiunta
        if (minNumInCart && quantity < minNumInCart) {
          // La nuova quantità è il minimo tra
          // la quantità minima carrello e il numero
          // massimo di pezzi che possono stare nel carrello
          newQuantity = Math.min(minNumInCart, quantity + maxAddable);
        }

        // Applico nuova quantità
        this.props.updateCartQuantity(product.id, newQuantity).then(() => {
          // Ricalcolo applicabilità coupon
          if (this.props.coupon.code && this.props.coupon.code.length > 2) {
            this.props.getCoupon(this.props.coupon.code);
          }
        });

        // GA4 ADD TO CART
        if (this.props.hasGoogleAnalytics4Advanced) {
          ga4AddToCart({ ...product, quantity: 1 });
        }

        // FKMX ADD TO CART
        if (this.props.hasFarmakomMetrics) {
          fkmxAddToCart({ ...product, quantity: 1 });
        }
      }
    }
  };

  remove = product => event => {
    event.preventDefault();

    if (!product.isFreeCorrelatedProduct) {
      if (
        this.props.cart.find(
          pr => pr.id === product.id && !!pr.isFreeCorrelatedProduct
        )
      ) {
        // aggiorno la quantità
        const quantity = 1;
        this.props.updateCartQuantity(product.id, quantity).then(() => {
          if (this.props.coupon.code && this.props.coupon.code.length > 2) {
            this.props.getCoupon(this.props.coupon.code);
          }
        });
      } else {
        // rimuovo
        this.props.removeFromCart(product).then(() => {
          if (this.props.coupon.code && this.props.coupon.code.length > 2) {
            this.props.getCoupon(this.props.coupon.code);
          }
        });

        if (this.props.advancedGa) {
          removeFromCartEvent({
            id: product.code || '',
            name: product.name,
            category: product.categoryName,
            brand: product.brand,
            price: product.price,
            quantity: product.quantity,
          });
        }

        // GA4 REMOVE FROM CART
        if (this.props.hasGoogleAnalytics4Advanced) {
          ga4RemoveFromCart(product);
        }

        // FKMX REMOVE FROM CART
        if (this.props.hasFarmakomMetrics) {
          fkmxRemoveFromCart(product);
        }
      }
    } else if (!!product.isFreeCorrelatedProduct) {
      if (
        this.props.cart.find(
          pr => pr.id === product.id && !pr.isFreeCorrelatedProduct
        )
      ) {
        // aggiorno la quantità
        const quantity = 1;
        this.props.updateCartQuantity(product.id, quantity).then(() => {
          if (this.props.coupon.code && this.props.coupon.code.length > 2) {
            this.props.getCoupon(this.props.coupon.code);
          }
        });
      } else {
        this.props.removeFromCart(product).then(() => {
          if (this.props.coupon.code && this.props.coupon.code.length > 2) {
            this.props.getCoupon(this.props.coupon.code);
          }
        });

        if (this.props.advancedGa) {
          removeFromCartEvent({
            id: product.code || '',
            name: product.name,
            category: product.categoryName,
            brand: product.brand,
            price: product.price,
            quantity: product.quantity,
          });
        }

        // GA4 REMOVE FROM CART
        if (this.props.hasGoogleAnalytics4Advanced) {
          ga4RemoveFromCart(product);
        }

        // FKMX REMOVE FROM CART
        if (this.props.hasFarmakomMetrics) {
          fkmxRemoveFromCart(product);
        }
      }
    }
  };

  checkCoupon = event => {
    this.props.setCoupon(event.target.value);
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('coupon', event.target.value);
    }
    if (event.target.value.length > 2) {
      this.props.getCoupon(event.target.value);
    }
  };

  handleProceed = () => {
    const { user } = this.props;
    if (
      user.data.billing.taxCode === '' ||
      user.data.billing.address1 === '' ||
      user.data.billing.phone === '' ||
      user.data.billing.zipcode === '' ||
      user.data.billing.city === '' ||
      user.data.billing.province === '' ||
      user.data.shipping.phone === '' ||
      user.data.shipping.zipcode === '' ||
      user.data.shipping.city === '' ||
      user.data.shipping.address1 === ''
    ) {
      browserHistory.push('/profilo?modifica=true');
    } else {
      // GA4 BEGIN CHECKOUT
      if (this.props.hasGoogleAnalytics4Advanced) {
        ga4BeginCheckout(this.props.cart, this.props.cartTotalDiscounted);
      }

      // FKMX BEGIN CHECKOUT
      if (this.props.hasFarmakomMetrics) {
        fkmxBeginCheckout(this.props.cart, this.props.cartTotalDiscounted);
      }

      // CHECK SE C'é UN COUPON E NON è VALIDO RIMUOVO
      if (!this.props.validCoupon) {
        this.props.resetCoupon();
        localStorage.removeItem('coupon');
      }

      // CHECK SE CI SONO PRODOTTI CHE RICHIEDONO UNA RICETTA
      const prescription = this.props.cart.find(
        product => !!product.prescription
      );
      if (!!prescription) {
        browserHistory.push('/ricetta');
      } else {
        browserHistory.push('/spedizione');
      }
    }
  };

  renderCartItems() {
    return this.props.cart
      .sort((a, b) => a.id - b.id)
      .map(product => {
        return (
          <ProdottoCarrello
            key={`${product.id}${
              product.isFreeCorrelatedProduct ? '_free' : ''
            }`}
            product={product}
            onIncrement={this.increment(product)}
            onDecrement={this.decrement(product)}
            onRemove={this.remove(product)}
            primaryColor={this.props.primaryColor}
            uiVariantButton={this.props.uiVariantButton}
          />
        );
      });
  }

  renderCouponButton = () => {
    const { validCoupon } = this.props;
    const { couponCode } = this.state;

    if (validCoupon) {
      return (
        <button
          style={{ backgroundColor: '#fc8080' }}
          className="custom-button"
          onClick={this.handleResetCoupon}
        >
          Rimuovi
        </button>
      );
    } else {
      return (
        <button className="custom-button" onClick={this.handleApplyCoupon}>
          Attiva
        </button>
      );
    }
  };

  calculateEarnedPoints = () => {
    const { fidelityPointsFarmaci, fidelityPointsAmount, cart } = this.props;

    const farmaci = cart.filter(
      product => product.type === 'farmaci' || product.taxCreditType === 'DRUG'
    );

    const totalPoints = fidelityPointsAmount * this.renderCartTotal();
    const farmaciTotalPrice = farmaci.reduce(
      (total, product) => total + product.price,
      0
    );

    const earnedPoints = fidelityPointsFarmaci
      ? parseInt(totalPoints)
      : parseInt(totalPoints - farmaciTotalPrice);

    return earnedPoints;
  };

  renderTotalButtons = (isMobile, minQuantityNotRespected, showInLeftSide) => {
    const {
      primaryColor,
      cartTotalDiscounted,
      validCoupon,
      discount,
      freeShippingThreshold,
      coupon,
      shippingCost,
      hasFidelityCard,
    } = this.props;

    const freeShippingPrice = Math.max(
      0,
      freeShippingThreshold - this.renderCartTotal()
    );
    const formattedDiscount = coupon.discount.toFixed(2).replace('.', ',');

    return (
      <div
        className={`total-buttons ${isMobile ? 'mobile' : 'desktop'}`}
        style={{
          backgroundColor: isMobile ? primaryColor : 'transparent',
        }}
      >
        <div
          className={`total ${
            isMobile && (validCoupon || discount.length > 4)
              ? 'with-discount'
              : ''
          }`}
          style={{ minWidth: isMobile ? '30%' : 'unset' }}
        >
          {!showInLeftSide && (
            <div
              style={{
                color:
                  isMobile && lightOrDark(primaryColor) === 'dark'
                    ? 'white'
                    : 'black',
              }}
            >
              <div>
                <div className="det subTotal">
                  <span className="text">Subtotale:</span>
                  <span className="amount" style={{ fontWeight: 200 }}>
                    €{' '}
                    {this.renderCartTotal()
                      .toFixed(2)
                      .replace('.', ',')}
                  </span>
                </div>
              </div>
              <div>
                <div className="det shipping">
                  <span className="text">Spedizione:</span>
                  <span className="amount" style={{ fontWeight: 200 }}>
                    {freeShippingPrice === 0
                      ? 'Gratuita'
                      : `€ ${shippingCost.toFixed(2).replace('.', ',')}`}
                  </span>
                </div>
              </div>
            </div>
          )}
          {!showInLeftSide && validCoupon && (
            <div
              style={{
                color:
                  isMobile && lightOrDark(primaryColor) === 'dark'
                    ? 'white'
                    : 'black',
              }}
            >
              <div className="det couponDiscount">
                <span className="text">Coupon:</span>
                <span className="amount" style={{ fontWeight: 200 }}>
                  € -{formattedDiscount}
                </span>
              </div>
            </div>
          )}
          {!showInLeftSide && (
            <div
              className="total"
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                color:
                  isMobile && lightOrDark(primaryColor) === 'dark'
                    ? 'white'
                    : 'black',
              }}
            >
              <span
                className="text"
                style={{ fontWeight: 600, fontSize: '18px' }}
              >
                Totale:{' '}
              </span>
              <span className="amount" style={{ fontSize: '18px' }}>
                <Price
                  amount={
                    freeShippingPrice === 0
                      ? cartTotalDiscounted
                      : cartTotalDiscounted + shippingCost
                  }
                />
              </span>
            </div>
          )}
        </div>
        {!showInLeftSide && !!hasFidelityCard && (
          <div className="fidelity-point-advice">
            <FidelityPointsEarned
              textColor={
                isMobile && lightOrDark(primaryColor) === 'dark'
                  ? 'white'
                  : 'black'
              }
            />
          </div>
        )}

        <div className="buttons">
          {!minQuantityNotRespected && !showInLeftSide && (
            <Button
              type="button"
              onClick={
                this.props.isAuthenticated
                  ? () => this.handleProceed()
                  : () => this.props.router.push('/accedi')
              }
              className={`btn ${
                isMobile ? 'btn-inverse' : 'btn-outline btn-thick'
              }`}
              style={{
                flex: isMobile ? 1 : 'unset',
                color: isMobile ? primaryColor : '#fff',
                backgroundColor: isMobile ? '#fff' : primaryColor,
                margin: 0,
                width: '22rem',
              }}
            >
              Procedi all'acquisto
            </Button>
          )}
        </div>
      </div>
    );
  };

  renderCouponWarning = () => {
    if (
      !this.props.couponIsAppliedToSopOtc &&
      this.props.coupon.minAmount &&
      this.props.cart.every(
        product =>
          product.type === 'farmaci' || product.taxCreditType === 'DRUG'
      )
    ) {
      return (
        <div className="coupon-warning">
          Per normativa il coupon <b>NON</b> può essere applicato a farmaci e
          omeopatici.
        </div>
      );
    } else if (
      !this.props.couponIsAppliedToSopOtc &&
      this.props.coupon.minAmount &&
      this.props.cart.some(
        product =>
          product.type === 'farmaci' || product.taxCreditType === 'DRUG'
      )
    ) {
      return (
        <div className="coupon-warning">
          Per normativa il coupon non sarà applicato a farmaci e omeopatici, ma{' '}
          <b>SOLO</b> ai parafarmaci.
        </div>
      );
    } else if (
      !this.props.coupon.loading &&
      this.props.coupon.minAmount > 0 &&
      this.props.cartTotalDiscountable < this.props.coupon.minAmount
    ) {
      return (
        <div className="coupon-warning">
          Aggiungi ancora{' '}
          <b>
            {Math.round(
              (this.props.coupon.minAmount - this.props.cartTotalDiscountable) *
                100
            ) / 100}{' '}
            €
          </b>{' '}
          per attivare il coupon.
        </div>
      );
    }
  };

  handleCategoryChange = category => {
    this.setState({ selectedCategory: category });
  };

  renderRecommendedItems() {
    const { selectedCategory } = this.state;
    const items = this.props.recommendedItems;

    const filteredItems = items.filter(
      item => item.tagName === selectedCategory
    );

    return filteredItems.map(product => {
      const productQuantity =
        this.state.productQuantities[product.id] !== undefined
          ? this.state.productQuantities[product.id]
          : 1;

      return (
        <div class="product-thumbnail-container">
          <ProductThumbnail
            key={`${product.id}${
              product.isFreeCorrelatedProduct ? '_free' : ''
            }`}
            productsThumbnail={this.props.productsThumbnail}
            secondaryColor={this.props.secondaryColor}
            quantity={productQuantity}
            disableGoToProduct={true}
            productToCart={true}
            product={product}
            list="tag"
          />
        </div>
      );
    });
  }

  recommendedCartLayout() {
    const { recommendedItems } = this.props;
    const tags = [...new Set(recommendedItems.map(item => item.tagName))];
    return (
      !!recommendedItems.length && (
        <div>
          <div>
            <p style={{ fontSize: '20px', fontWeight: '600' }}>
              Raggiungi la spedizione gratuita con:
            </p>
          </div>
          <div
            className="recommended-buttons"
            style={{ display: 'flex', padding: '10px', overflow: 'scroll' }}
          >
            {tags.map(tag => (
              <button
                key={`recommended_tag_${tag}`}
                className="tab-button"
                style={
                  this.state.selectedCategory === tag
                    ? { borderBottom: '1px solid #000000', color: '#000' }
                    : {}
                }
                onClick={() => this.handleCategoryChange(tag)}
              >
                {tag.toUpperCase()}
              </button>
            ))}
          </div>
          <div className="recommended-container">
            {this.renderRecommendedItems()}
          </div>
        </div>
      )
    );
  }

  render() {
    const {
      validCoupon,
      primaryColor,
      location,
      cart,
      uiVariantInputText,
      siteName,
      siteUrl,
      logoImage,
      freeShippingThreshold,
      hasFidelityCard,
    } = this.props;

    const freeShippingPrice = Math.max(
      0,
      (freeShippingThreshold - this.renderCartTotal()).toFixed(2)
    );

    const carrelloStyle = css`
      .promo .promo-code {
        input {
          border-radius: ${uiVariantInputText === '1'
            ? '12px'
            : uiVariantInputText === '3'
            ? '30px'
            : 0};

          &:focus {
            box-shadow: none;
            border-color: ${primaryColor}!important;
          }
        }
        .promo-check {
          color: ${primaryColor}!important;
        }
      }
    `;

    const minQuantityNotRespected = cart.reduce((acc, product) => {
      const minQuantityNotRespectedOnProduct =
        product.minNumInCart && product.quantity < product.minNumInCart;
      return acc || minQuantityNotRespectedOnProduct;
    }, false);

    const changedQuantity = cart.filter(
      product =>
        !!product.availableLessThanRequested &&
        typeof product.availableLessThanRequested === 'number'
    );

    return (
      <div className="carrello" css={carrelloStyle}>
        <Helmet
          title="Il tuo carrello"
          meta={[
            {
              name: 'description',
              content: `${siteName} - Ecommerce Farmacia - Carrello`,
            },
            {
              name: 'keywords',
              content: `${siteName}, Ecommerce Farmacia - Carrello`,
            },
            {
              name: 'robots',
              content: 'index, follow',
            },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:title',
              content: `Carrello | ${siteName} - Ecommerce Farmacia`,
            },
            {
              property: 'og:description',
              content: `${siteName} - Ecommerce Farmacia - Carrello`,
            },
            { property: 'og:image', content: logoImage },
          ]}
          link={[
            {
              rel: 'canonical',
              href: `${siteUrl}/carrello`,
            },
          ]}
        />
        <div className="container">
          <div className="main-container">
            <h1>Il tuo carrello</h1>

            <div className="message">
              <MessaggioChiusura type="cart" />
            </div>

            {(location.query.na || !!changedQuantity.length) && (
              <div className="not-available-box">
                <p>
                  Purtroppo almeno un prodotto ora non è più disponibile nella
                  quantità che avevi inserito nel carrello.
                </p>
                <p>
                  Abbiamo aggiornato il carrello con le quantità effettivamente
                  disponibili (<span style={{ color: '#c00' }}>in rosso</span>).
                </p>
                {changedQuantity.map(product => {
                  const singularOrPlurale =
                    product.availableLessThanRequested === 1 ? 'o' : 'i';
                  return (
                    <p style={{ fontWeight: 'bold' }}>
                      {` - ${product.name}, rimoss${singularOrPlurale} ${product.availableLessThanRequested} pezz${singularOrPlurale}`}
                    </p>
                  );
                })}
              </div>
            )}

            <div className="product-container">
              <div className="title">
                <h2 className="t-1">Prodotto</h2>
                <h2 className="t-2">Prezzo</h2>
                <h2 className="t-3">Quantità</h2>
                <h2 className="t-4">Subtotale</h2>
              </div>

              {this.renderCartItems()}

              {minQuantityNotRespected && (
                <div className="min-in-cart">
                  Non è possibile procedere all'ordine perché almeno un prodotto
                  non rispetta la quantità minima.
                </div>
              )}
            </div>
            {this.renderTotalButtons(
              this.props.isMobile,
              minQuantityNotRespected,
              true
            )}
          </div>

          <div
            className="menu-container"
            style={{
              height: 'fit-content',
            }}
          >
            <h4>Riepilogo ordine</h4>

            <Threshold
              threshold={freeShippingThreshold}
              subTotal={this.renderCartTotal()}
              shippingCost={this.props.shippingCost}
            />

            <div className="cart-coupon">
              <div className="input-with-button">
                {validCoupon && (
                  <div className="promo-check coupon-check">
                    <FaCheck />
                  </div>
                )}
                <input
                  type="text"
                  className="form-control"
                  placeholder="Hai un codice coupon?"
                  value={
                    typeof this.state.couponCode !== 'undefined'
                      ? this.state.couponCode
                      : this.props.coupon.code
                  }
                  onChange={e => this.setState({ couponCode: e.target.value })}
                  disabled={validCoupon}
                />
                {this.renderCouponButton()}
              </div>
            </div>
            {this.renderCouponWarning()}

            {this.renderTotalButtons(
              this.props.isMobile,
              minQuantityNotRespected,
              false
            )}

            {!!hasFidelityCard && (
              <div>
                <FidelityPoint className="fidelity-point" borderRatio="0px" />
              </div>
            )}
          </div>
        </div>
        {freeShippingPrice != '0' && (
          <div className="carrello">
            <div className="container" style={{ paddingLeft: '0px' }}>
              <div className="main-container">
                {this.recommendedCartLayout()}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isMobile: state.layout.isMobile,
    user: state.user,
    cart: state.cart,
    checkout: state.checkout,
    coupon: state.checkout.coupon,
    isAuthenticated: state.user.authenticated,
    siteName: state.store.data.datiFarmacia.siteName,
    logoImage: state.store.data.loghiTemplate.logoImage,
    siteUrl: state.store.data.datiFarmacia.siteUrl,
    globalState: state,
    cartTotal: getCartTotal(state),
    cartTotalDiscountable: getCartTotalDiscountable(state),
    cartTotalDiscounted: getCartTotalDiscountedCoupon(state),
    validCoupon: isValidCoupon(state),
    discount: getDiscount(state),
    advancedGa: state.store.data.features.advancedGa,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    uiVariantButton: state.store.data.uiVariants.buttons,
    uiVariantInputText: state.store.data.uiVariants.inputText,
    hasCriteo: state.store.data.features.hasCriteo,
    hasDynamicRemarketing: state.store.data.features.hasDynamicRemarketing,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
    criteoAccountId: state.store.data.integrazioni.criteo.accountId,
    couponIsAppliedToSopOtc:
      state.store.data.funzionalita.couponIsAppliedToSopOtc,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
    hasTradedoubler: state.store.data.features.hasTradedoubler,
    tradedoubler: state.store.data.integrazioni.tradedoubler,
    freeShippingThreshold:
      state.checkout.shippingAbroadThreshold ||
      state.store.data.costiSpedizione.freeShippingThreshold,
    shippingCost: state.checkout.shippingCost,
    recommendedItems: state.recommendedItems.data,
    hasFidelityCard: state.store.data.features.hasFidelityCard,
    fidelityPointsAmount: state.store.data.fidelityPoints.currencyAmount,
    fidelityPointsFarmaci: !!state.store.data.fidelityPoints.enableSopOtc,
  };
}

export default withRouter(
  connect(mapStateToProps, {
    removeFromCart,
    updateCartQuantity,
    setCoupon,
    resetCoupon,
    getCoupon,
    loadRecommendedItems,
  })(Carrello)
);
